import { Subject } from 'rxjs';

import { KeyValue } from '../../interfaces';
import { ToggleSegmentDetail } from './toggle-segment-detail';

export interface SelectableCards {
  icons?: KeyValue<string, string>;
  secondaryIcon?: KeyValue<string, string>;
  images?: KeyValue<string, string>[];
  isBorder?: boolean;
  amount?: string;
  amountLegalSign?: string;
  amountAltText?: string;
  discountAmount?: string;
  tileHeading?: string;
  linkText?: string;
  isRadioOrCheckBox?: string;
  productId?: string;
  isDefaultProduct?: boolean;
  isToggle?: boolean;
  isPrimaryColorForToggle?: boolean;
  isRadioUncheckAllowed?: boolean;
  isAddon?: boolean;
  modalDescription?: string;
  serviceCategory?: string;
  groupId?: string;
  modalImages?: KeyValue<string, string>[];
  modalTitle?: string;
  modalButtonText?: string;
  toggleSegmentDetails?: KeyValue<string, ToggleSegmentData>[];
  isClicked?: boolean;
  addOnProductId?: string;
  selectedToggleSegmentDetail?: ToggleSegmentDetail;
  charges?: string;
  disableSelection?: boolean;
  updateCheckboxState?: Subject<UpdateCheckboxStateEvent>;
}

export interface ToggleSegmentData {
  productId?: string;
  amount?: string;
  discountAmount?: string;
  isSelected?: boolean;
}

export interface UpdateCheckboxStateEvent {
  productId: string;
  isChecked: boolean;
}

export interface ResetCheckStateEvent {
  radioOrCheckbox: SelectableCardInputType;
  productId: string;
  isChecked: boolean;
}

export enum SelectableCardInputType {
  RADIO = 'Radio',
  CHECKBOX = 'Checkbox',
}
